import { Button } from "@rshbintech.dboul/core-ui";
import { FooterCsiProps } from "./types";
import styles from "./styles.scss";

export const FooterCsi = ({
  submitButtonText,
  onSubmit,
  onReject,
  isSubmitDisabled,
}: FooterCsiProps) => (
  <div className={styles.container}>
    <div className={styles["buttons-block"]}>
      <Button
        className={styles.button}
        htmlType="button"
        type="outline-neutral"
        onClick={onReject}
      >
        Отмена
      </Button>
      <Button
        disabled={isSubmitDisabled}
        className={styles.button}
        htmlType="button"
        onClick={onSubmit}
      >
        {submitButtonText}
      </Button>
    </div>
  </div>
);
